import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const LastUpdated = (props) => {
  const { latestTimestamp } = props;

  return (
    <div
      style={{
        color: '#A7B7C0',
        fontSize: 13,
        fontWeight: 400,
      }}
    >
      {latestTimestamp ? (
        <>
          updated
          {' '}
          {moment.unix(latestTimestamp).fromNow()}
        </>
      ) : (
        <>
          No data available
        </>
      )}
    </div>
  );
};

LastUpdated.propTypes = {
  latestTimestamp: PropTypes.number,
};

LastUpdated.defaultProps = {
  latestTimestamp: 0,
};

export default LastUpdated;
